import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  NumberField,
  SearchInput,
  TextField,
  useRecordContext,
} from "react-admin";
import { Box, Typography } from "@mui/material";

const filters = [<SearchInput key="q" source="q" alwaysOn placeholder="Поиск по пути / сервису" />];

type LogRecord = Record<string, unknown> & { id?: unknown };

const DetailField = ({ label, source, mono }: { label: string; source: string; mono?: boolean }) => {
  const record = useRecordContext<LogRecord>();
  const value = record?.[source];
  if (value === undefined || value === null || value === "") return null;
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Typography
        component="pre"
        variant="body2"
        sx={{
          m: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
          fontFamily: mono ? "monospace" : "inherit",
          fontSize: 12,
        }}
      >
        {String(value)}
      </Typography>
    </Box>
  );
};

const ExceptionExpand = () => (
  <Box sx={{ p: 2, bgcolor: "background.default" }}>
    <DetailField label="Сообщение" source="ErrorMessage" />
    <DetailField label="Тип" source="ExceptionType" mono />
    <DetailField label="Стек" source="StackTrace" mono />
    <DetailField label="Тело запроса" source="RequestBody" mono />
    <DetailField label="Query" source="QueryString" mono />
    <DetailField label="TraceId" source="TraceId" mono />
    <DetailField label="RequestId" source="RequestId" mono />
    <DetailField label="Пользователь" source="UserId" />
    <DetailField label="IP" source="ClientIp" />
    <DetailField label="User-Agent" source="UserAgent" />
  </Box>
);

const SlowExpand = () => (
  <Box sx={{ p: 2, bgcolor: "background.default" }}>
    <DetailField label="Query" source="QueryString" mono />
    <DetailField label="Тело запроса" source="RequestBody" mono />
    <DetailField label="Тело ответа" source="ResponseBody" mono />
    <DetailField label="TraceId" source="TraceId" mono />
    <DetailField label="RequestId" source="RequestId" mono />
    <DetailField label="Пользователь" source="UserId" />
    <DetailField label="IP" source="ClientIp" />
    <DetailField label="User-Agent" source="UserAgent" />
  </Box>
);

const TruncatedText = ({ source, max = 80 }: { source: string; max?: number }) => (
  <FunctionField
    source={source}
    render={(record: LogRecord) => {
      const v = record?.[source];
      if (v == null) return "";
      const s = String(v);
      return s.length > max ? `${s.slice(0, max)}…` : s;
    }}
  />
);

export const ExceptionLogList = () => (
  <List filters={filters} sort={{ field: "CreatedAt", order: "DESC" }} perPage={50}>
    <Datagrid expand={<ExceptionExpand />} bulkActionButtons={false}>
      <TextField source="Id" label="ID" />
      <DateField source="CreatedAt" label="Время" showTime />
      <TextField source="ServiceName" label="Сервис" />
      <TextField source="Method" label="Метод" />
      <TextField source="Path" label="Путь" />
      <NumberField source="StatusCode" label="HTTP" />
      <NumberField source="ErrorCode" label="Код" />
      <TruncatedText source="ErrorMessage" />
    </Datagrid>
  </List>
);

export const SlowRequestLogList = () => (
  <List filters={filters} sort={{ field: "CreatedAt", order: "DESC" }} perPage={50}>
    <Datagrid expand={<SlowExpand />} bulkActionButtons={false}>
      <TextField source="Id" label="ID" />
      <DateField source="CreatedAt" label="Время" showTime />
      <TextField source="ServiceName" label="Сервис" />
      <TextField source="Method" label="Метод" />
      <TextField source="Path" label="Путь" />
      <NumberField source="StatusCode" label="HTTP" />
      <NumberField source="DurationMs" label="мс" />
      <TextField source="ClientIp" label="IP" />
    </Datagrid>
  </List>
);
